<template>
  <div class="ticket-portal-footer">
    <img v-bind="logo" :width="16" :height="16">
    <a href="https://www.donedone.com" target="_blank" rel="noopener noreferrer nofollow">Powered by DoneDone</a>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'TicketPortalFooter',

  components: {},

  data() {
    return {
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
    }
  },
})
</script>

<style lang="scss">
.ticket-portal-footer {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 4px 12px;
  border: solid 1px $color--gray-30;
  border-radius: 20px;
  background-color: var(--color-background-header);
  width: fit-content;
  white-space: nowrap;

  @include lettering--p-sm;

  @include media-breakpoint-down(sm) {
    right: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  a {
    color: inherit;
    text-decoration: none;
    margin-left: 4px;
  }
}
</style>
